import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG } from "@/types";
import { Link } from "react-router-dom";

function CompleteProfile({
  level,
  isCompany,
  isProfile,
}: {
  level?: string | boolean;
  isProfile: boolean;
  isCompany: boolean;
}) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <div
      dir={locale == LANG.AR ? "rtl" : "ltr"}
      className="bg-gray-100 my-2 h-44 font-bold flex flex-col justify-center px-2 xl:px-10 rounded-2xl"
    >
      <div className="flex xl:flex-nowrap flex-wrap px-2 xl:items-center justify-end lg:justify-between">
        <div className="flex items-center xl:gap-10 gap-3">
          <div className="border-4 border-green-500 xl:w-20 xl:h-20 min-w-14 h-14 text-sm flex flex-col items-center rounded-full justify-center">
            {level}
          </div>
          <div>
            <div className="xl:text-2xl md:text-lg text-base">
              {t("profile.completeProfile.title")}
            </div>
            <div className="font-medium xl:text-base text-sm text-gray-800 mt-3">
              {t("profile.completeProfile.des")}
            </div>
            <div className="font-medium xl:text-base text-sm text-gray-800">
              {t("profile.completeProfile.subDes")}
            </div>
            {isCompany && (
              <div className="text-red-500 mt-4">
                - {t("profile.completeProfile.company")}
              </div>
            )}
            {isProfile && (
              <div className="text-red-500 mt-4">
                - {t("profile.completeProfile.profile")}
              </div>
            )}
          </div>
        </div>
        <Link to={routes.settings} className="mt-2 xl:mt-0">
          <div className="bg-black text-sm xl:text-xl text-white px-4 py-2 rounded-full">
            {t("navigation.Settings")}
          </div>
        </Link>
      </div>
    </div>
  );
}

export default CompleteProfile;
